// Скрытый замер текста таблицы для `useTableColumns`.
import { cn } from '@teach/ui'
import { cellKey, cellWords, wordKey } from '@/features/editor/lib/tableColumns'
import { TABLE_CELL_CLASS } from '@/features/editor/lib/tableStyles'

/** Скрытые строки для замера: каждая ячейка целиком и каждое её слово, с полями
 *  ячейки (они входят в ширину колонки). Шапка (строка 0) — жирная. */
export const TableMeasure = ({ texts, sizeClass }: { texts: string[][]; sizeClass: string }) => (
  <div
    aria-hidden
    className="pointer-events-none invisible absolute left-0 top-0 h-0 w-max overflow-hidden whitespace-nowrap"
  >
    {texts.flatMap((row, r) =>
      row.flatMap((text, c) => {
        const cls = cn(sizeClass, TABLE_CELL_CLASS, 'inline-block', r === 0 ? 'font-bold' : null)
        const words = [...new Set(cellWords(text))].map((word) => (
          <span key={wordKey(r, c, word)} data-measure={wordKey(r, c, word)} className={cls}>
            {word}
          </span>
        ))
        return text
          ? [
              <span key={cellKey(r, c)} data-measure={cellKey(r, c)} className={cls}>
                {text}
              </span>,
              ...words,
            ]
          : words
      }),
    )}
  </div>
)
